<p>external-redirect works!</p>
